import component from "./ParticipantSchedule";

export default component;
